import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';
import HomePage from '../home';

const About: React.FC = () => {
  usePageVistTracker();

  return (
    <Layout
      description="Use Brain.fm's functional music to help you focus better, using cutting edge neuroscience to get results."
      pageTitle="Improve Focus"
    >
      <HomePage  />
    </Layout>
  );
};

export default About;
